import { render, staticRenderFns } from "./verificationRequired.vue?vue&type=template&id=d1a1b8cc&scoped=true&"
import script from "./verificationRequired.vue?vue&type=script&lang=js&"
export * from "./verificationRequired.vue?vue&type=script&lang=js&"
import style0 from "./verificationRequired.vue?vue&type=style&index=0&id=d1a1b8cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a1b8cc",
  null
  
)

export default component.exports